<template>
<div class="chapter">
<div class="inner_page">
<div class="imagefp"><img alt="The Spider: An Elemental Assassin Book, by Jennifer Estep." class="imagefp" src="images/9781451689068_cover.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?68670767